import {useConferenceSettingsStore} from '@features/appointment/conference-settings'
import {
	buildAudioPublishPreset
} from '@features/appointment/conference-settings/ui/conference-settings-modal/conference-settings.constants'
import {MicrophoneBitrateSync} from '@features/appointment/conference-settings'
import {LiveKitRoom} from '@livekit/components-react'
import {AudioPresets, VideoPresets} from 'livekit-client'
import React, {useMemo} from 'react'
import s from './appointment-context.module.scss'

export const AppointmentContext = ({appointment_token, setIsConf, isConf, children}) => {
	const { selectedAudioBitrate } = useConferenceSettingsStore();

	// options должен оставаться стабильным: useLiveKitRoom пересоздаёт Room при каждом
	// изменении options, что приводит к переподключению и отключению микрофона/камеры.
	// Поэтому publishDefaults фиксируются при первом рендере, а смена качества аудио
	// применяется к уже опубликованному микрофону через MicrophoneBitrateSync.
	/* eslint-disable react-hooks/exhaustive-deps -- options должен оставаться стабильным, иначе переподключение */
	const roomOptions = useMemo(() => ({
		publishDefaults: {
			videoEncoding: VideoPresets.h720.encoding,
			screenShareEncoding: VideoPresets.h1080.encoding,
			audioPreset: {
					...buildAudioPublishPreset(selectedAudioBitrate),
					priority: 'high'
			},
			dtx: false,
			red: false,
		},
		videoCaptureDefaults: {
			resolution: VideoPresets.h720.resolution,
		},
		audioPreset: AudioPresets.musicHighQualityStereo,
		audioCaptureDefaults: {
			autoGainControl: false,
			echoCancellation: true,
			noiseSuppression: false,
			voiceIsolation: false,
			channelCount : 2,
            sampleRate: 48000,
            latency: 0,
            googHighpassFilter: false,
		}}), []);
	/* eslint-enable react-hooks/exhaustive-deps */

	return (
		<LiveKitRoom
      video={true}
      audio={true}
      token={appointment_token}
      onDisconnected={() => setIsConf(false)}
      serverUrl={process.env.REACT_APP_LIVE_KIT_SERVER_URL}
      data-lk-theme="default"
      className={s.wrapper}
      connect={isConf}
			options={roomOptions}
    >
			<MicrophoneBitrateSync />
			{children}
		</LiveKitRoom>
	)
}
